export default "__VITE_ASSET__CtjDtLyY__"